// Filter properties for the sync activity log's AdvancedFilters row builder.
//
// The shape is declared rather than inferred: without it TypeScript widens the array to a union of
// the individual literal shapes, and `autofillOptions` is then unreachable on any member that
// happens to lack it.
interface FilterOption {
  label: string;
  value: string;
}

export interface SyncActivityFilter {
  autofillOptions?: FilterOption[];
  isDate?: boolean;
  isNumerical?: boolean;
  label: string;
  operators: string[];
  value: string;
}

//
// AIDEV-NOTE: `http_method_eq` resolves through LmsSyncEvent's `http_method` ransacker, which
// compares on LOWER(). The column holds 'post', 'POST' and 'get' depending on which client wrote
// the row, so a plain equality filter would match almost nothing. Send lowercase values.
const HTTP_METHOD_OPTIONS: FilterOption[] = [
  { label: 'POST', value: 'post' },
  { label: 'GET', value: 'get' },
  { label: 'PUT', value: 'put' },
  { label: 'PATCH', value: 'patch' },
  { label: 'DELETE', value: 'delete' },
];

const STRING_OPERATORS = ['eq', 'not_eq', 'cont', 'not_cont'];

const STUDENT_FILTERS: SyncActivityFilter[] = [
  { label: 'First Name', operators: STRING_OPERATORS, value: 'student_first_name' },
  { label: 'Last Name', operators: STRING_OPERATORS, value: 'student_last_name' },
  { label: 'Username', operators: STRING_OPERATORS, value: 'student_username' },
];

// The student filters only earn their place on the assignment-wide view. When the log is already
// scoped to one student they can only narrow the list to nothing, so they are left out.
const syncActivityFilters = (scopedToStudent: boolean): SyncActivityFilter[] => [
  { isDate: true, label: 'Date', operators: ['eq', 'not_eq', 'gteq', 'lteq'], value: 'created_at' },
  ...(scopedToStudent ? [] : STUDENT_FILTERS),
  { isNumerical: true, label: 'HTTP Status', operators: ['eq', 'not_eq'], value: 'http_status' },
  {
    autofillOptions: HTTP_METHOD_OPTIONS,
    label: 'HTTP Method',
    operators: ['eq', 'not_eq'],
    value: 'http_method',
  },
  { label: 'Category', operators: STRING_OPERATORS, value: 'category' },
];

export { HTTP_METHOD_OPTIONS };
export default syncActivityFilters;
